/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M6 6h1.5v1.5H6a.5.5 0 0 0-.5.5v2H4V8c0-1.1046.8954-2 2-2ZM4 16v-2h1.5v2a.5.5 0 0 0 .5.5h1.5V18H6c-1.1046 0-2-.8954-2-2ZM10.5 6h3v1.5h-3V6ZM16.5 6H18c1.1046 0 2 .8954 2 2v2h-1.5V8a.5.5 0 0 0-.5-.5h-1.5V6ZM20 14v2c0 1.1046-.8954 2-2 2h-1.5v-1.5H18a.5.5 0 0 0 .5-.5v-2H20ZM13.5 18h-3v-1.5h3V18Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 6c0-2.2091 1.7909-4 4-4h16c2.2091 0 4 1.7909 4 4v12c0 2.2091-1.7909 4-4 4H4c-2.2091 0-4-1.7909-4-4V6Zm4-2.5h16c1.3807 0 2.5 1.1193 2.5 2.5v12c0 1.3807-1.1193 2.5-2.5 2.5H4c-1.3807 0-2.5-1.1193-2.5-2.5V6c0-1.3807 1.1193-2.5 2.5-2.5Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuContainers'
);
